import { ChannelConfig } from "./ChannelConfig"
import { Vector3 } from 'three/src/math/Vector3'

const awsChannel: ChannelConfig = {
    showInChannelList: true,
    passwordProtected: false,
    id: "aws",
    
    tickerSeparator: "by",
    streamURL: "https://memustream.live:8443/awsstream",
    streamURLDev: "https://memustream.live:8443/awsstream",
    metadataURL: "https://memustream.live/memu/aws/aws_ticker.json",

    name: "AWS",
    channelListName: "AWS",
    urlSlug: "aws",
    attributionDescription: "The best MEMU config settings, tried and tested",
    colorsGradient2: [
       // AWS Orange: RGB(255, 153,   0) → normalized (1.0, 0.6, 0.0)
       new Vector3(255/255, 153/255,   0/255),
   
       // AWS Dark Gray: RGB( 51,  51,  51) → normalized (0.2, 0.2, 0.2)
       new Vector3( 51/255,  51/255,  51/255)
     ]
   }
export default awsChannel